import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
import { offerAnchor } from '../data/content';
import { recentPurchases } from '../data/purchases';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState<number | null>(null);
  useEffect(() => {
    let count = 0;
    let hideTimer: number | undefined;
    let interval: number | undefined;
    const show = () => {
      setIndex(count % recentPurchases.length);
      count += 1;
      hideTimer = window.setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(() => {
      show();
      interval = window.setInterval(show, INTERVAL);
    }, FIRST_DELAY);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(interval);
    };
  }, []);
  const purchase = index === null ? null : recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-[60] md:bottom-6 md:left-6" data-id="element-225" data-mp="164oa074zg5up">
      <AnimatePresence data-id="element-226" data-mp="116cylrz1hnad">
        {purchase && <motion.a key={index} href={offerAnchor} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-[280px] items-center gap-3 rounded-xl border-[3px] border-yellow-300 bg-blue-700 p-3 shadow-2xl shadow-blue-950/50" data-id="element-227" data-mp="1fwbwdtmomwpb">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-yellow-300" data-id="element-228" data-mp="s67wnxcm7h3l">
              <ShoppingBagIcon className="h-5 w-5 text-blue-950" aria-hidden="true" data-id="element-229" data-mp="28jyavwxg7lqy" />
            </span>
            <span className="min-w-0 text-left" data-id="element-230" data-mp="23lwhai2ec418">
              <span className="block text-sm font-extrabold leading-tight text-white" data-id="element-231" data-mp="23l3ka8t8oswa">
                {purchase.name}{' '}
                <span className="font-semibold text-white/85" data-id="element-232" data-mp="2fno139kjn9zm">
                  from {purchase.city}, {purchase.country}
                </span>
              </span>
              <span className="mt-0.5 block text-xs text-white/90" data-id="element-233" data-mp="2knahfrvo56cn">
                just purchased the Complete Sports Massage Bundle
              </span>
              <span className="mt-0.5 block text-[10px] font-bold uppercase tracking-wider text-yellow-300" data-id="element-234" data-mp="1rylkm51nbn6p">
                {purchase.time}
              </span>
            </span>
          </motion.a>}
      </AnimatePresence>
    </div>;
}